import { render, staticRenderFns } from "./TableDataCell.vue?vue&type=template&id=d0ca02ce&"
import script from "./TableDataCell.vue?vue&type=script&lang=js&"
export * from "./TableDataCell.vue?vue&type=script&lang=js&"
import style0 from "./TableDataCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports